export const GET_COUNTRY_URL = "/api/country";
export const GET_STATE_URL = "/api/state/";
export const GET_CITY_URL = "/api/city/";
export const GET_DISTRICT_URL = "/api/district/";
export const GET_SPORT_URL = "/api/findRefSport";
export const POST_SCHEME_DOC_DATA = "/api/apply/uploadDoc";
export const POST_SCHEME_DATA = "/api/apply/create";
export const GET_SCHEMES_URL = "/api/schemes/all";
export const GET_USER_DATA = "/api/user/profile";
export const GET_USER_SCHEME_STAT = "/api/user/stats";
export const GET_USER_SCHEME_APPLICATIONS = "/api/apply/allUserAppliedSchemes/";
export const POST_SCHEME_RESUBMIT_DATA = "/api/apply/resubmit-application";
export const GET_SCHEME_APPLICATION_REMARK_DATA = "/api/schemes/allRemarks";
// Assessment Management
export const GET_ASSESSMENT_RECORDS = "/api/forms/my-records";